import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from "swiper/modules";

const PageSwiper = ({ slidesData }) => {
    return (
        <Swiper
            spaceBetween={30}
            speed={2000}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            effect={"fade"}
            fadeEffect={{ crossFade: true }}
            modules={[Autoplay, EffectFade]}
            className="mySwiper"
        >
            {slidesData.map((slide, index) => (
                <SwiperSlide key={index}>
                    <img src={slide.backgroundImage} alt={slide.alt} className="object-cover w-full h-[50vh] md:h-[70vh]" />
                    <div className="absolute inset-0 bg-black/20"></div>
                    <div className="absolute inset-0 flex items-center justify-center">
                        <div className="text-center">
                            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">{slide.title}</h1>
                            <p className="text-white/80">{slide.desc}</p>
                        </div>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

PageSwiper.propTypes = {
    slidesData: PropTypes.array.isRequired
};
export default PageSwiper;